<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
    </div>
    <!-- <div class="admin-load" >

<div class="admin-loader" id="admin-loader"></div>
<div class="admin-loader" id="admin-loader2"></div>
<div class="admin-loader" id="admin-loader3"></div>
<div class="admin-loader" id="admin-loader4"></div>

<span id="admin-text">LOADING...</span>

   </div> -->
    <!-- <div class="my-add-spinner" v-if="loading">
        <div class="my-add-spinner-text">Loading</div>
        <div class="my-add-spinner-sector my-add-spinner-sector-red"></div>
        <div class="my-add-spinner-sector my-add-spinner-sector-blue"></div>
        <div class="my-add-spinner-sector my-add-spinner-sector-green"></div>
      </div> -->

    <!-- <div v-if="loading1" class="mx-auto pt-5 col-12 col-sm-8 col-md-6">
    <div class="spinner">
        <div class="spinner-text">Updating</div>
        <div class="spinner-sector spinner-sector-red"></div>
        <div class="spinner-sector spinner-sector-blue"></div>
        <div class="spinner-sector spinner-sector-green"></div>
      </div>
 </div> -->
    <div class="" v-if="changed">
      <b-container class="col-lg-10 mt-5">
        <h3 class="text-info text-center pt-4 my-4">Quotations</h3>
        <!-- User Interface controls -->
        <el-card
          shadow="always"
          style="background-color: #f5f7fa; overflow: initial"
        >
          <b-row>
            <!-- <b-col sm="4" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-datepicker
                  placeholder="Start Date"
                  id="start-datepicker"
                  v-model="startDate"
                  class="mb-2"
                  :isRTL="true"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col sm="4" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-datepicker
                  placeholder="End Date"
                  id="end-datepicker"
                  v-model="endDate"
                  class="mb-2"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
              </b-form-group>
            </b-col> -->
            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <el-date-picker
                  size="medium"
                  v-model="month"
                  :picker-options="{
                    disabledDate: (time) => disabledDate(time),
                  }"
                  type="month"
                  placeholder="Month"
                >
                </el-date-picker>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-select
                  placeholder="Store Location"
                  v-model="storeLocation"
                  :options="stores"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-input
                  v-model="invoiceNo"
                  placeholder="Quotation No"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-input
                  v-model="customer"
                  placeholder="Customer's Mobile No"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <!-- <b-col sm="3" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-form-select
                  v-model="cashier"
                  :options="options2"
                ></b-form-select>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col sm="12" class="my-1">
              <b-form-group label="" class="mb-0">
                <el-button
                  style="display: block; margin: 0 auto; margin-top: 10px"
                  type="primary"
                  size="medium"
                  @click="searchInvoices"
                  >Search</el-button
                >
              </b-form-group>
            </b-col>
          </b-row>
        </el-card>
        <b-row>
          <!-- <b-col sm="4" class="my-1">
        <b-form-group  label="" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col> -->
          <!-- <b-col sm="5" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions">
                  <option slot="first" :value="null">Sort By</option>
                </b-form-select>
                <b-form-select
                  :disabled="!sortBy"
                  v-model="sortDesc"
                  slot="append"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="3" class="my-1">
            <b-form-group horizontal class="mb-0">
              <b-form-select v-model="perPage">
                <option disabled>per page</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="40">40</option>
              </b-form-select>
            </b-form-group>
          </b-col> -->
        </b-row>
        <PrintInvo printInvoType="quota" />
        <!-- Main table element -->
        <el-card style="overflow-x: scroll;" shadow="always">
          <b-table
            show-empty
            stacked="sm"
            :items="items"
            :fields="fields"
            :hover="true"
            head-variant="dark"
            :current-page="currentPage"
            :per-page="perPage"
            :empty-text="emptyText"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            class="mt-4"
          >
            <template slot="index" slot-scope="data">
              {{ data.index + 1 }}
            </template>

            <template slot="actions" slot-scope="row">
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->

                <a
                  size="sm"
                  @click.stop="row.toggleDetails"
                  class="btn btn-sm btn-info text-white"
                >
                  View
                </a>
                <router-link
                  :to="{
                    name: 'create-quotation',
                    query: { Quo: row.item.invoiceNo },
                  }"
                  class="btn btn-sm btn-primary"
                >
                  Update
                </router-link>
                <a
                  size="sm"
                  @click="printInvoice(storeLocation, row.item)"
                  class="btn btn-sm btn-secondary text-white"
                >
                  Print
                </a>
                <!-- <a
                  size="sm"
                  @click="open(row.item.id)"
                  class="btn btn-sm btn-danger text-white"
                >
                  Delete
                </a> -->
              </div>
            </template>

            <template slot="row-details" slot-scope="row">
              <b-card>
                <el-row :gutter="10" style="margin-top: 20px">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-card class="box-card" style="background-color: #eaf0ff">
                      <div class="clearfix text item">
                        <span>Gross Amount</span>
                        <span style="float: right; padding: 3px 0"
                          >{{ row.item.grossAmount.toLocaleString() }} LKR</span
                        >
                      </div>
                      <div class="clearfix text item">
                        <span>Discount</span>
                        <span style="float: right; padding: 3px 0"
                          >{{ row.item.discount.toLocaleString() }} LKR
                        </span>
                      </div>
                      <div class="clearfix text item">
                        <span>Other Discount</span>
                        <span style="float: right; padding: 3px 0">
                          {{ row.item.otherDiscount.toLocaleString() }} LKR
                        </span>
                      </div>
                      <div class="clearfix text item">
                        <span>Tax/Service Charge</span>
                        <span style="float: right; padding: 3px 0">
                          {{ row.item.tax.toLocaleString() }} LKR
                        </span>
                      </div>
                      <div class="clearfix text item">
                        <span>Net Amount</span>
                        <span style="float: right; padding: 3px 0"
                          >{{ row.item.netAmount.toLocaleString() }} LKR</span
                        >
                      </div>
                      <!-- <div class="clearfix">
            <span style="color: #000; margin-bottom: 5px">Payment Details</span>
          </div> -->
                      <!-- <div class="clearfix text item">
                        <span>Card Payment</span>
                        <span style="float: right; padding: 3px 0">
                          {{ row.item.cardPayment.toLocaleString() }} LKR
                        </span>
                      </div>
                      <div class="clearfix text item">
                        <span>Cash Payment</span>
                        <span style="float: right; padding: 3px 0">
                          {{ row.item.cashPayment.toLocaleString() }} LKR
                        </span>
                      </div>
                      <div class="clearfix text item">
                        <span>Cheque Payment</span>
                        <span style="float: right; padding: 3px 0">
                          {{ row.item.chequePayment.toLocaleString() }} LKR
                        </span>
                      </div>
                      <div class="clearfix text item">
                        <span>Balance</span>
                        <span style="float: right; padding: 3px 0"
                          >{{ row.item.balance.toLocaleString() }} LKR</span
                        >
                      </div> -->
                    </el-card>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <h5 class="text-center text-info my-4">Items Summary</h5>
                    <div class="">
                      <b-table
                        show-empty
                        stacked="sm"
                        :items="row.item.products"
                        :fields="productsFields"
                        :hover="true"
                        head-variant="dark"
                        :empty-text="emptyText"
                        :filter="filter"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                       
                        class="mt-4"
                      >
                        <template slot="cell(index)" slot-scope="data">
                          {{ data.index + 1 }}
                        </template>
                      </b-table>
                    </div>
                  </el-col>
                </el-row>
              </b-card>
            </template>
          </b-table>
        </el-card>
        <b-col md="3" class="my-1">
          <b-form-group label="" class="mb-0">
            <b-form-select v-model="perPage">
              <option disabled>per page</option>
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="40">40</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
        <!-- Info modal -->
        <!-- <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
      <pre>{{ modalInfo.content }}</pre>
       <AddProduct/>
    </b-modal> -->
      </b-container>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import PrintInvo from "./PrintInvo.vue";
const items = [];
export default {
  name: "invoicelist",
  components: { PrintInvo },
  data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [
        "index",
        //  { key: 'id', label: 'Order id', sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "invoiceNo", label: "Quotations No", sortable: true },
        // { key: "storeLocation", label: "Store" },
        { key: "customer", label: "Customer", sortable: true },
        // { key: "grossAmount", label: "Gross Amount", sortable: true },
        // { key: "discount", label: "Discount", sortable: true },
        // { key: "otherDiscount", label: "Other Discount", sortable: true },
        // { key: "tax", label: "tax", sortable: true },
        { key: "netAmount", label: "Net Amount", sortable: true },
        // { key: "cardPayment", label: "Card Payment", sortable: true },
        // { key: "cashPayment", label: "Cash Payment", sortable: true },
        // { key: "balance", label: "Balance", sortable: true },
        // { key: "status", label: "Status", sortable: true },
        { key: "updatedBy", label: "Updated By", sortable: true },
        { key: "updated", label: "Updated", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      productsFields: [
        "index",
        { key: "name", label: "Name", sortable: true },
        { key: "barcode", label: "Barcode", sortable: true },
        { key: "category", label: "Category", sortable: true },
        { key: "subcategory", label: "Sub Category", sortable: true },
        { key: "quantity", label: "Quantity", sortable: true },
        { key: "price", label: "Price", sortable: true },
        { key: "discount", label: "Discount", sortable: true },
        { key: "subTotal", label: "Sub Total", sortable: true },
      ],
      stores: this.$store.state.stores,
      storeLocation: this.$store.state.selectedStore,
      month: new Date(),
      invoiceNo: "",
      customer: "",
      cashier: null,
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: false,
      shops: [],
      orders: "",
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    printInvoice(storeLocation, item) {
      const store = this.$store.state.stores.find(
        (store) => store.id === storeLocation
      );
      this.$root.$emit("printClicked", store, item);
    },
    disabledDate(date) {
      return date > new Date();
    },
    searchInvoices() {
      console.log("month", this.month);
      if (!this.month && this.customer === "" && this.invoiceNo === "") {
        return alert("Please select month");
      }
      if (
        !this.storeLocation &&
        this.customer === "" &&
        this.invoiceNo === ""
      ) {
        return alert("Please select store location");
      }
      this.loading = true;
      this.changed = false;
      this.items = [];
      // console.log(
      //   "values",
      //   this.month,
      //   this.storeLocation,
      //   this.invoiceNo,
      //   this.customer
      // );
      const docRef =
        this.$store.state.secondaryDatabase.collection("quotations");
      let firestoreQuery = docRef;
      if (this.month) {
        const date = new Date(this.month);
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        console.log("dates", firstDay, lastDay);
        firestoreQuery = firestoreQuery.where(
          "date",
          ">=",
          firebase.firestore.Timestamp.fromDate(firstDay)
        );
        firestoreQuery = firestoreQuery.where(
          "date",
          "<=",
          firebase.firestore.Timestamp.fromDate(lastDay)
        );
      }
      if (this.storeLocation) {
        firestoreQuery = firestoreQuery.where(
          "storeLocation",
          "==",
          this.storeLocation
        );
      }
      if (this.invoiceNo) {
        firestoreQuery = firestoreQuery.where(
          "invoiceNo",
          "==",
          this.invoiceNo
        );
      }
      if (this.customer) {
        firestoreQuery = firestoreQuery.where(
          "customerMobile",
          "==",
          this.customer
        );
      }
      firestoreQuery
        .orderBy("date", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              products: doc.data().products,
              date: doc.data().date.toDate().toLocaleString(),
              invoiceNo: doc.data().invoiceNo,
              storeLocation: doc.data().storeLocation,
              cashier: doc.data().cashier,
              cashierName: doc.data().cashierName,
              customer: doc.data().customer,
              customerMobile: doc.data().customerMobile,
              grossAmount: doc.data().grossAmount,
              discount: doc.data().discount,
              otherDiscount: doc.data().otherDiscount,
              tax: doc.data().tax,
              netAmount: doc.data().netAmount,
              cardPayment: doc.data().cardPayment,
              cashPayment: doc.data().cashPayment,
              chequePayment: doc.data().chequePayment,
              balance: doc.data().balance,
              updated: doc.data().updated.toDate().toLocaleString(),
              updatedBy: doc.data().updatedBy,
            };
            this.items.push(data);
            this.totalRows = this.items.length;
          });
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          this.loading = false;
          this.changed = true;
        });
    },
    open(id) {
      this.$confirm(
        "This will permanently delete the item. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.deleteOrder(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    // open2(id) {
    //   this.$confirm('This will change the order status. Continue?', 'Warning', {
    //     confirmButtonText: 'OK',
    //     cancelButtonText: 'Cancel',
    //     type: 'warning',
    //     center: true
    //   }).then(() => {
    //     this.upOrder(id)
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'Change canceled'
    //     });
    //   });
    // },
    open3() {
      this.$notify.info({
        title: "Info",
        message: "Order status is updated",
      });
    },
    upOrder(id, status, refid) {
      this.$store.state.secondaryDatabase
        .collection("orders")
        .doc(id)
        .update({
          status: status,
        })
        .then(() => {
          this.open3();
          db.collection("orders")
            .doc(refid)
            .update({
              status: status,
            })
            .then(() => {})
            .catch((error) => alert(error));
        })
        .catch((error) => alert(error));
    },

    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "fast",
        "swing"
      );
    },
  },
  created() {
    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    //  db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
    //   .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id': doc.id,
    //     }
    //     this.shops.push(data)
    //   })
    this.backToTop();
    this.loading = true;
    this.changed = false;
    this.$store.state.secondaryDatabase
      .collection("quotations")
      .where("storeLocation", "==", this.$store.state.selectedStore)
      .orderBy("date", "desc")
      .limit(10)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            products: doc.data().products,
            date: doc.data().date.toDate().toLocaleString(),
            invoiceNo: doc.data().invoiceNo,
            storeLocation: doc.data().storeLocation,
            cashier: doc.data().cashier,
            cashierName: doc.data().cashierName,
            customer: doc.data().customer,
            customerMobile: doc.data().customerMobile,
            grossAmount: doc.data().grossAmount,
            discount: doc.data().discount,
            otherDiscount: doc.data().otherDiscount,
            tax: doc.data().tax,
            netAmount: doc.data().netAmount,
            cardPayment: doc.data().cardPayment,
            cashPayment: doc.data().cashPayment,
            chequePayment: doc.data().chequePayment,
            balance: doc.data().balance,
            updated: doc.data().updated.toDate().toLocaleString(),
            updatedBy: doc.data().updatedBy,
          };
          this.items.push(data);
          this.totalRows = this.items.length;
        });
        if (this.items.length == 0) {
          this.emptyText = "There are no records to show";
        }

        this.loading = false;
        this.changed = true;
      });
    // this.$store.state.secondaryDatabase
    //   .collection("shops")
    //   .where("owner", "==", firebase.auth().currentUser.uid)
    //   .get()
    //   .then((querySnapshot) => {
    //     querySnapshot.forEach((doc) => {
    //       const data = {
    //         id: doc.id,
    //         orders: doc.data().orders,
    //       };
    //       this.shops.push(data);
    //       this.orders = this.shops[0].orders;
    //     });
    //   });
    // })
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>




// WEBPACK FOOTER //
// src/components/admin/Quotations.vue